import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import {IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import CancelIcon from '@mui/icons-material/Cancel';
import {AgyleSubmitIcon} from '../../../../../components/icons/agyle';
import {Fragment} from 'react';
import {getFormCustomTitle} from '../../../../../util/patientContextUtil';
import {useSelector} from 'react-redux';
import {ctxBlockExitForm} from '../../../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) =>
    ({
        root: {
            margin: 10,
            padding: 10,
        },
        divRow: {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10,
        },
        backButton: {
            backgroundColor: theme.palette.inPatient.formBackground,
        },
        title: {
            fontWeight: 'bold',
        },
        right: {
            marginLeft: 'auto',
            marginRight: 'inherit',
        },
    }),
);

const FullFormContextPanel = ({
                                  form,
                                  onSave,
                                  onClose,
                                  disableSave,
                                  patientType,
                                  patientAgeType,
                                  disableTitle,
                                  customSubmitButtonText,
                                  hideSubmit = false,
                                  buttons = [],
                              }) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const isBlockExitForm = useSelector(ctxBlockExitForm);

    const handleSubmit = () => {
        onSave();
    };

    return (
        <div className={clsx(classes.root, classes.divRow)} id="full-form-header">
            {!disableTitle &&
                <>
                    {!isBlockExitForm &&
                        <IconButton
                            className={classes.backButton}
                            onClick={onClose}
                        >
                            <CloseIcon/>
                        </IconButton>
                    }

                    <span className={classes.title}>
                        {getFormCustomTitle(form, patientType, patientAgeType)}
                    </span>
                </>
            }

            <div className={clsx(classes.right, classes.divRow)}>
                {buttons?.map((btn, index) => (
                    <Fragment key={index}>
                        {btn}
                    </Fragment>
                ))}

                {!isBlockExitForm &&
                    <AgyleButton
                        startIcon={<CancelIcon/>}
                        onClick={onClose}
                        colour="primary"
                    >
                        {t('Close')}
                    </AgyleButton>
                }

                {!hideSubmit &&
                    <AgyleButton
                        variant="contained"
                        startIcon={customSubmitButtonText !== 'Submit' ? null : <AgyleSubmitIcon/>}
                        onClick={handleSubmit}
                        disabled={disableSave}
                    >
                        {t(customSubmitButtonText)}
                    </AgyleButton>
                }
            </div>
        </div>
    );
};

export default FullFormContextPanel;